import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import axios from 'axios';

dayjs.extend(utc);
dayjs.extend(localizedFormat);

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.get['Content-Type'] = 'application/json';
var maxios;
if (process.env.REACT_APP_API_BASEURL === undefined) {
  maxios = axios.create({
    headers: {
      'Content-Type': 'application/json',
    },
  });
} else {
  maxios = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASEURL}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function get(url) {
  try {
    url = url.replace('undefined', '');
    const response = await maxios.get(url);
    return response?.data;
  } catch (error) {
    // Handle the error by returning a structured object or throwing a custom error
    return handleAxiosError(error);
  }
}

export async function post(url, data) {
  try {
    url = url.replace('undefined', '');
    const response = await maxios.post(url, data);
    return response;
  } catch (error) {
    // Handle the error by returning a structured object or throwing a custom error
    return handleAxiosError(error);
  }
}

export function handleAxiosError(error) {
  if (error.response) {
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    return {
      status: error.response.status,
      message: error.response.data?.message || 'An error occurred',
      headers: error.response.headers,
    };
  } else if (error.request) {
    // The request was made but no response was received
    return {
      status: 'Network Error',
      message: 'No response received from the server',
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    return {
      status: 'Error',
      message: error.message,
    };
  }
}

export function FormatDate(date) {
  return dayjs(date).isValid() ? dayjs(date).format('M/D/YYYY') : '';
}
export function FormatDateUsingTimeZone(date, dateOnly = false) {
  return dateOnly
    ? dayjs.utc(date).local().format('L')
    : dayjs.utc(date).local().format('L LT');
}
export function convertUTCDateToLocalDate(date) {
  var newDate = new Date(date + 'Z');

  return newDate;
}
export function FormatDateNullable(date) {
  if (!date || !dayjs(date).isValid()) return '';
  else return dayjs(date).format('M/D/YYYY');
}

export function extractReferralId(referralIdString) {
  const returnString = referralIdString.split('=');

  return returnString[1];
}
